module.exports = __webpack_public_path__ + "static/img/Logotipo_Positivo_Vertical-recibo-2.39e14d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Logotipo_Positivo_Vertical-recibo-2.png
// module id = WUd1
// module chunks = 2